// extracted by mini-css-extract-plugin
module.exports = {"menuTravelContainer":"TImeTravelModal_menuTravelContainer__2iZdl","menuTravelBtn":"TImeTravelModal_menuTravelBtn__2ucVx"};